<template>
  <div :class="col">
    <a @click="chooseImage">
      <template v-if="model">
        <v-img alt="upload_img" class="shrink mr-2 image-border" :src="model" transition="scale-transition"
          :width="width" :height="height" />
      </template>
      <template v-else>
        <v-img alt="upload_img" class="shrink mr-2" src="../../assets/upload_img.png" transition="scale-transition"
          :width="width" :height="height" style="border-radius: 10px;" />
      </template>
    </a>
    <v-file-input :id="id" accept="image/*" placeholder="Upload Image" prepend-inner-icon="fas fa-plus"
      background-color="#ffffff" style="display: none" @change="uploadImage">
    </v-file-input>
  </div>
</template>

<script>
import { url } from "../../util/Constants";
import Swal from "sweetalert";

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    col: "",
    height: "",
    width: "",
    model: "",
    name: "",
    menu: '',
    branch_id: '',
    path: '',
    errorSize: ''
  },
  name: "InputImageUpload",
  data() {
    return {};
  },
  methods: {
    chooseImage() {
      document.getElementById(`${this.id}`).click();
    },
    uploadImage(file) {
      if (file) {

        console.log(file.size, this.errorSize * 1000)
        if (file.size > this.errorSize * 1000) {
          Swal('', `Upload file size error (> ${this.errorSize}KB)`, 'error');
          return;
        }
        const reader = new FileReader();
        reader.onload = e => {
          const base64 = e.target.result;
          // eslint-disable-next-line camelcase
          const file_name = this.name ? this.name : file.name;
          const menu = this.menu;
          const branch_id = this.branch_id;
          const path = this.path;
          const data = {
            base64,
            file_name,
            menu,
            branch_id,
            path
          };
          this.$store
            .dispatch("Utility/getPathImage", data)
            .then(path => {
              const fullImagePath = url + path;
              const imagePath = path;
              this.$emit("update", { fullImagePath, imagePath, file_name });
            })
            .catch(() => {
              Swal('', 'Failed to upload file', 'error');
            });
        };
        reader.readAsDataURL(file);
      }
    },
    setModelData(val) {
      this.$emit("update", val);
    }
  }
};
</script>

<style scoped>
.fa-plus-square {
  background-color: white;
}

.image-border {
  object-fit: contain !important;
  border: #9E9E9E solid 1px !important;
  border-radius: 10px;
}
</style>
